<template>
    <div
        :class="[
            'service-package-section-card',
            {
                'service-package-section-recommended': servicePackage.isRecommended,
            },
        ]">
        <ServicePackage
            :addon="servicePackage"
            :usps="servicePackage.usps"
            :modelValue="modelValue"
            :isSelected="modelValue"
            @update:modelValue="onUpdate" />
    </div>
</template>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';
    import { ServicePackageAddon, ServicePackageType } from '@/api/Cart/cart.interfaces';
    import { getServicePackageContent } from './ServicePackage.helpers';
    import ServicePackage from '@ui/components/ServicePackage/ServicePackage.vue';

    export default defineComponent({
        name: 'ServicePackageCard',
        components: {
            ServicePackage,
        },
        props: {
            modelValue: {
                type: Boolean as PropType<boolean | undefined>,
                default: undefined,
            },
            addon: { type: Object as PropType<ServicePackageAddon>, required: true },
        },
        emits: ['update:modelValue'],
        setup(props, { emit }) {
            const servicePackage = getServicePackageContent(props.addon);

            function onUpdate(state: boolean) {
                emit('update:modelValue', state);
            }
            return { servicePackage, ServicePackageType, onUpdate };
        },
    });
</script>
